document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function(block = document) {
        const switchers = block.querySelectorAll('.content-switcher');
        if (!switchers.length) return;

        switchers.forEach(switcher => {
            const tabs = switcher.querySelectorAll('.content-switcher__tab');
            const panels = switcher.querySelectorAll('.content-switcher__panel');
            const isMobile = window.matchMedia('(max-width: 960px)').matches;

            // Find currently active tab index (or default to 0)
            let activeTabIndex = 0;
            
            // First try to find active tab
            tabs.forEach((tab, index) => {
                if (tab.classList.contains('active') || tab.getAttribute('aria-selected') === 'true') {
                    activeTabIndex = index;
                }
            });
            
            // If no active tab found, check for active panel
            if (activeTabIndex === 0) {
                panels.forEach((panel, index) => {
                    if (panel.classList.contains('active') && !panel.hasAttribute('hidden')) {
                        activeTabIndex = index;
                    }
                });
            }

            // Clean up any existing mobile headers first
            switcher.querySelectorAll('.content-switcher__panel-header').forEach(header => {
                header.remove();
            });

            if (isMobile) {
                // Convert to accordion on mobile
                panels.forEach((panel, index) => {
                    // Only create header if it doesn't exist
                    if (!panel.previousElementSibling?.classList.contains('content-switcher__panel-header')) {
                        const header = document.createElement('button');
                        header.className = 'content-switcher__panel-header';
                        header.type = 'button';

                        // Get tab text for header
                        const correspondingTab = tabs[index];
                        header.textContent = correspondingTab?.textContent || 'Panel';

                        header.addEventListener('click', () => {
                            const isActive = panel.classList.contains('active');

                            // Close all panels
                            panels.forEach(p => {
                                p.classList.remove('active');
                            });
                            switcher.querySelectorAll('.content-switcher__panel-header').forEach(h => {
                                h.classList.remove('active');
                            });

                            // Toggle current panel
                            if (!isActive) {
                                panel.classList.add('active');
                                header.classList.add('active');
                            }
                        });

                        panel.parentNode.insertBefore(header, panel);
                    }

                    // Reset all panels to collapsed state on mobile
                    panel.removeAttribute('hidden'); // Always show panels on mobile for accordion
                    panel.classList.remove('active'); // All panels collapsed by default

                    // Ensure all headers are not active
                    const correspondingHeader = panel.previousElementSibling;
                    if (correspondingHeader && correspondingHeader.classList.contains('content-switcher__panel-header')) {
                        correspondingHeader.classList.remove('active');
                    }
                });
            } else {
                // Desktop tab behavior - maintain active tab state
                if (panels.length > 0) {
                    // Ensure only the active panel is visible
                    panels.forEach((panel, index) => {
                        if (index === activeTabIndex) {
                            panel.classList.add('active');
                            panel.removeAttribute('hidden');
                        } else {
                            panel.classList.remove('active');
                            panel.setAttribute('hidden', '');
                        }
                    });
                    
                    // Initialize tabindex for proper keyboard navigation (desktop only)
                    tabs.forEach((tab, index) => {
                        if (index === activeTabIndex) {
                            tab.setAttribute('tabindex', '0');
                            tab.setAttribute('aria-selected', 'true');
                            tab.classList.add('active');
                        } else {
                            tab.setAttribute('tabindex', '-1');
                            tab.setAttribute('aria-selected', 'false');
                            tab.classList.remove('active');
                        }
                    });
                }
                
                tabs.forEach((tab, tabIndex) => {
                    // Handle keyboard navigation
                    tab.addEventListener('keydown', (e) => {
                        let newIndex = tabIndex;
                        
                        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                            newIndex = (tabIndex + 1) % tabs.length;
                            e.preventDefault();
                        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                            newIndex = (tabIndex - 1 + tabs.length) % tabs.length;
                            e.preventDefault();
                        }
                        
                        if (newIndex !== tabIndex) {
                            tabs[newIndex].click();
                            tabs[newIndex].focus();
                        }
                    });
                    
                    tab.addEventListener('click', () => {
                        const panelId = tab.getAttribute('aria-controls');
                        const targetPanel = switcher.querySelector(`#${panelId}`);
                        
                        if (!targetPanel) return;
                        
                        // Update tabs
                        tabs.forEach(t => {
                            t.setAttribute('aria-selected', 'false');
                            t.setAttribute('tabindex', '-1');
                            t.classList.remove('active');
                        });
                        tab.setAttribute('aria-selected', 'true');
                        tab.setAttribute('tabindex', '0');
                        tab.classList.add('active');
                        
                        // Update panels with proper fade transition
                        const currentPanel = switcher.querySelector('.content-switcher__panel.active');
                        
                        if (currentPanel && currentPanel !== targetPanel) {
                            // Fade out current panel
                            currentPanel.classList.add('fade-out');
                            currentPanel.classList.remove('active');
                            
                            // After fade out, hide it and show new panel
                            setTimeout(() => {
                                currentPanel.classList.remove('fade-out');
                                currentPanel.setAttribute('hidden', '');
                                
                                // Show and fade in target panel
                                targetPanel.removeAttribute('hidden');
                                targetPanel.classList.add('active');
                                // Force reflow
                                targetPanel.offsetHeight;
                                targetPanel.classList.add('fade-in');
                                
                                // Clean up fade-in class
                                setTimeout(() => {
                                    targetPanel.classList.remove('fade-in');
                                }, 50);
                            }, 50);
                        } else if (currentPanel === targetPanel) {
                            // Same panel clicked - do nothing
                            return;
                        } else {
                            // No current panel (shouldn't happen) - hide all others first
                            panels.forEach(p => {
                                if (p !== targetPanel) {
                                    p.classList.remove('active');
                                    p.setAttribute('hidden', '');
                                }
                            });
                            targetPanel.removeAttribute('hidden');
                            targetPanel.classList.add('active');
                        }
                    });
                });
            }
        });

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                initializeBlock();
            }, 250);
        });
    };
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=content-switcher', initializeBlock);
    } else {
        initializeBlock();
    }
});